// extracted by mini-css-extract-plugin
export default {"root":"styles_root__WPqZi","pdf-link":"styles_pdf-link__wzLoG","img":"styles_img__q2+5m","menu":"styles_menu__-F0ed","menu-ul":"styles_menu-ul__nQEiD"};